module.exports = __webpack_public_path__ + "static/media/pindrop.1b19fc92.svg";